import r from "dayjs";
import n from "dayjs/plugin/customParseFormat.js";
import i from "dayjs/plugin/duration.js";
import o from "dayjs/plugin/isSameOrAfter.js";
import Y from "dayjs/plugin/isSameOrBefore.js";
import M from "dayjs/plugin/relativeTime.js";
import f from "dayjs/plugin/updateLocale.js";
import u from "dayjs/plugin/utc.js";
const l = [
  { l: "s", r: 4, d: "second" },
  { l: "ss", r: 59, d: "second" },
  { l: "m", r: 1 },
  { l: "mm", r: 59, d: "minute" },
  { l: "h", r: 1 },
  { l: "hh", r: 23, d: "hour" },
  { l: "d", r: 1 },
  { l: "dd", r: 29, d: "day" },
  { l: "M", r: 1 },
  { l: "MM", r: 11, d: "month" },
  { l: "y" },
  { l: "yy", d: "year" }
];
r.extend(i);
r.extend(f);
r.extend(M, { thresholds: l });
r.extend(n);
r.extend(Y);
r.extend(o);
r.extend(u);
r.updateLocale("en", {
  relativeTime: {
    ...r.Ls.en.relativeTime,
    ss: "%d seconds"
  }
});
var h = /* @__PURE__ */ ((e) => (e.date = "DD.MM.YYYY", e.dateUs = "MM.DD.YYYY", e.dateIso = "YYYY-MM-DD", e.fullTime = "HH:mm:ss", e.dateWithTime = "DD.MM.YYYY HH:mm", e.dateWithFullTime = "DD.MM.YYYY HH:mm:ss", e.dateWithTextMonthYear = "DD MMM YYYY", e.dateWithTextMonthTime = "DD MMM YYYY, HH:mm", e.dateWithTextMonthTimeShort = "DD MMM HH:mm", e.dateWithMonth = "DD MMM", e.daysAndHours = "DD[d] HH[h]", e.hoursAndMinutes = "HH:mm", e.minutesAndSecond = "mm:ss", e.backendFormat = "YYYY-MM-DDTHH:mm:ss.ssssss[Z]", e))(h || {});
function H(e, s = "DD.MM.YYYY") {
  return r(e).format(s);
}
function v(e, s) {
  return r(e).fromNow(s);
}
function A(e) {
  return (s) => H(s, e);
}
function S(e, s) {
  return r(e, s, !0).isValid();
}
function L(e, s) {
  const d = r(e), m = r(s), t = r.duration(m.diff(d));
  return t.format(
    t.days() ? "DD[d] HH[h]" : "HH:mm:ss"
    /* fullTime */
  );
}
export {
  h as D,
  v as a,
  A as b,
  L as d,
  H as f,
  S as i
};
//# sourceMappingURL=dates.js.map
